import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoginInitComponent } from './login.component';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    FormsModule
  ],
  declarations: [LoginInitComponent],
  exports: [
    LoginInitComponent
  ],
  providers: [
    NgxSpinnerService
  ]
})
export class LoginModule { }
